import { motion } from 'framer-motion';
import QuoteBuilder from './QuoteBuilder';
import { useI18n } from './i18n';

const fadeUp = {
  hidden: { opacity: 0, y: 30 },
  visible: (i = 0) => ({
    opacity: 1, y: 0,
    transition: { duration: 0.6, delay: i * 0.1, ease: 'easeOut' },
  }),
};

export default function LandingFormation() {
  const { t } = useI18n();
  return (
    <section className="pt-32 pb-24 bg-gradient-to-b from-slate-50 to-white min-h-screen">
      <div className="max-w-3xl mx-auto px-6">
        <motion.div initial="hidden" animate="visible">
          <motion.h1
            variants={fadeUp} custom={0}
            className="text-3xl sm:text-4xl font-light text-slate-900 mb-4"
            style={{ fontFamily: "'Outfit', sans-serif" }}
          >
            {t.formation.title}
          </motion.h1>
          <motion.p variants={fadeUp} custom={1} className="text-base text-slate-500 mb-10 max-w-2xl">
            {t.formation.subtitle}
          </motion.p>
        </motion.div>
        <motion.div initial="hidden" animate="visible" variants={fadeUp} custom={2}>
          <QuoteBuilder />
        </motion.div>
      </div>
    </section>
  );
}
